import {getTextByParameter} from "../textOptions";
import {decryptPasswordBased} from "./encryptionCrypto";
import {APP_SALT, ID_TOKEN, TOKEN_STRING} from '../../conf';
import {SessionInterface} from "../../services/interface/SessionInterface";
import {getSessionToken, removeSessionToken} from "../../services/configuration/cookiesConfig";

// Cache en memoria por clave
const sessionCache: Record<string, SessionInterface> = {};

export function getSessionByCookie(keyName: string): SessionInterface | null {
    if (!keyName) return null;

    if (sessionCache[keyName]) {
        return sessionCache[keyName];
    }

    const stored = getSessionToken(keyName);
    if (!stored) return null;

    try {
        const token = JSON.parse(stored);

        if (token?.session && token?.key) {
            const session = decryptPasswordBased(
                token.session,
                getTextByParameter(keyName),
                APP_SALT,
                token.key
            );

            sessionCache[keyName] = session;
            return session;
        }
    } catch (error) {
        console.error("Error parsing session token:", error);
    }

    return null;
}

export function findToken(idToken: string): string {
    const token = getSessionByCookie(idToken)?.access_token;
    return `${TOKEN_STRING}${token}`;
}

export function clearCookiesAndCache() {
    removeSessionToken(ID_TOKEN);
    Object.keys(sessionCache).forEach(k => delete sessionCache[k]);
}
